import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageOptionsPopUpButtonComponent } from './page-options-pop-up-button.component';
import { DxButtonModule } from 'devextreme-angular';



@NgModule({
  declarations: [
    PageOptionsPopUpButtonComponent
  ],
	exports: [
		PageOptionsPopUpButtonComponent,
	],
  imports: [
    CommonModule,

		DxButtonModule
  ]
})
export class PageOptionsPopUpButtonModule { }
